var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33278 7.57289H15.6684C16.0233 7.57289 16.3102 7.28521 16.3102 6.9311V5.89667C16.3102 5.54181 16.0226 5.25488 15.6684 5.25488H2.33278C1.97791 5.25488 1.69099 5.54256 1.69099 5.89667V6.9311C1.69023 7.28521 1.97791 7.57289 2.33278 7.57289Z",
    fill: "#373E51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4564 15.6308H16.2121V14.5149C16.2121 14.1238 15.895 13.8066 15.5038 13.8066L2.4958 13.8074C2.10469 13.8074 1.78756 14.1245 1.78756 14.5156V15.6308H0.543232C0.241212 15.6308 -0.000404358 15.8725 -0.000404358 16.1745C-0.000404358 16.4705 0.241212 16.7181 0.543232 16.7181H17.4564C17.7584 16.7181 18 16.4705 18 16.1745C18 15.8725 17.7584 15.6308 17.4564 15.6308Z",
    fill: "#373E51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9708 3.74753C14.9708 3.33829 14.7436 2.96378 14.3812 2.77578L9.5065 0.234369C9.18863 0.0690125 8.81033 0.0690125 8.49322 0.234369L3.61856 2.77578C3.25614 2.96455 3.02886 3.33906 3.02886 3.74753V4.16809H14.9715V3.74753H14.9708ZM9.84472 3.11405H8.15416C7.85365 3.11405 7.61052 2.87092 7.61052 2.57041C7.61052 2.2699 7.85365 2.02677 8.15416 2.02677H9.84472C10.1452 2.02677 10.3884 2.2699 10.3884 2.57041C10.3884 2.87092 10.1452 3.11405 9.84472 3.11405Z",
    fill: "#373E51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02882 8.65918H5.31432V12.7199H3.02882V8.65918Z",
    fill: "#373E51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6859 8.65918H14.9714V12.7199H12.6859V8.65918Z",
    fill: "#373E51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8567 8.65918H10.1422V12.7199H7.8567V8.65918Z",
    fill: "#373E51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.25646573b7717b4f18c90aec091656d0.svg";
export { ForwardRef as ReactComponent };